module.exports = __webpack_public_path__ + "static/media/Kevin Mwandau.0815cf5a.jpeg";